import React from 'react';
import type { ArticleImage } from '../types/article';
interface ArticleFigureProps {
  image: ArticleImage;
  className?: string;
}
export function ArticleFigure({
  image,
  className = ''
}: ArticleFigureProps) {
  return <figure className={className} data-id="element-8" data-mp="1ok5npe8uan0v">
      <img src={image.src} alt={image.alt} className="block w-full rounded-lg object-cover" data-id="element-9" data-mp="1oh9s3wkgsafl" />
      {image.caption && <figcaption className="mt-2 text-[13px] leading-relaxed text-neutral-500" data-id="element-10" data-mp="1xizf8q7bcn7k">
          {image.caption}
        </figcaption>}
    </figure>;
}